export const convertToArray = (value?: string | null) => {
  return value === null || typeof value === 'undefined' || value.length === 0
    ? []
    : value.split(',');
};
